import FilterContainer from "components/FilterContainer";
import { AanbiederFilter } from "components/filters/AanbiederFilter";
import { AangebodenSindsFilter } from "components/filters/AangebodenSindsFilter";
import { AantalCilindersFilter } from "components/filters/AantalCilindersFilter";
import { AantalDeurenFilter } from "components/filters/AantalDeurenFilter";
import { AantalZitplaatsenFilter } from "components/filters/AantalZitplaatsenFilter";
import { ActieradiusFilter } from "components/filters/ActieradiusFilter";
import { AfstandFilter } from "components/filters/AfstandFilter";
import { AudioEnTelefonieFilter } from "components/filters/AudioEnTelefonieFilter";
import { BouwjaarFilter } from "components/filters/BouwjaarFilter";
import { BrandstofFilter } from "components/filters/BrandstofFilter";
import { CarrosserievormFilter } from "components/filters/CarrosserivormFilter";
import { DraaicirkelFilter } from "components/filters/DraaicirkelFilter";
import { EmissieklasseFilter } from "components/filters/EmissieklasseFilter";
import { ExterieurFilter } from "components/filters/ExterieurFilter";
import { GarantiesEnZekerhedenFilter } from "components/filters/GarantiesEnZekerhedenFilter";
import { ImportAutoFilter } from "components/filters/ImportAutoFilter";
import { InterieurEnComfortFilter } from "components/filters/InterieurEnComfortFilter";
import { KilometerstandFilter } from "components/filters/KilometerstandFilter";
import { KleurFilter } from "components/filters/KleurFilter";
import { KofferbakinhoudFilter } from "components/filters/KofferbakinhoudFilter";
import { LedigGewichtFilter } from "components/filters/LedigGewichtFilter";
import { MotorinhoudFilter } from "components/filters/MotorinhoudFilter";
import { PrijsFilter } from "components/filters/PrijsFilter";
import { BTWFilter } from "components/filters/BTWFilter";
import { TransmissieFilter } from "components/filters/TransmissieFilter";
import { TrefwoordFilter } from "components/filters/TrefwoordFilter";
import { TrekgewichtFilter } from "components/filters/TrekgewichtFilter";
import { VeiligheidEnTechniekFilter } from "components/filters/VeiligheidEnTechniekFilter";
import { VerbruikFilter } from "components/filters/VerbruikFilter";
import { VerlichtingFilter } from "components/filters/VerlichtingFilter";
import { VermogenFilter } from "components/filters/VermogenFilter";
import { VoertuigsoortFilter } from "components/filters/VoertuigsoortFilter";
import { EnergieLabelFilter } from "components/filters/EnergieLabelFilter";
import React from "react";

const basicFields = [
    // { label: "Merk & Model", isOpen: true, component: () => <div /> }, // not using this on the home page
    { label: "Carrosserievorm", isOpen: true, component: () => <CarrosserievormFilter /> },
    { label: "Bouwjaar", isOpen: true, component: () => <BouwjaarFilter /> },
    { label: "Prijs", isOpen: true, component: () => <PrijsFilter /> },
    { label: "BTW", isOpen: true, component: () => <BTWFilter condensed />, testId: "btw" },
    { label: "Kilometerstand", isOpen: true, component: () => <KilometerstandFilter /> },
    { label: "Afstand", isOpen: true, component: () => <AfstandFilter /> },
    { label: "Transmissie", isOpen: true, component: () => <TransmissieFilter /> },
    { label: "Brandstof", isOpen: true, component: () => <BrandstofFilter /> },
    { label: "Trefwoord", isOpen: true, component: () => <TrefwoordFilter /> },
    { label: "Aantal deuren", isOpen: true, component: () => <AantalDeurenFilter /> },
    { label: "Voertuigsoort", isOpen: true, component: () => <VoertuigsoortFilter /> },
    { label: "Aangeboden sinds", isOpen: true, component: () => <AangebodenSindsFilter /> },
    //
    { label: "Kleur", isOpen: true, component: () => <KleurFilter /> },
    { label: "Import auto", isOpen: true, component: () => <ImportAutoFilter /> }
];

const fieldGroups = [
    {
        label: "Opties en accessoires",
        isOpen: true,
        fields: [
            {
                label: "Interieur en comfort",
                isOpen: false,
                component: () => <InterieurEnComfortFilter />
            },
            {
                label: "Exterieur",
                isOpen: false,
                component: () => <ExterieurFilter />
            },
            {
                label: "Veiligheid en techniek",
                isOpen: false,
                component: () => <VeiligheidEnTechniekFilter />
            },
            {
                label: "Audio en telefonie",
                isOpen: false,
                component: () => <AudioEnTelefonieFilter />
            },
            {
                label: "Verlichting",
                isOpen: false,
                component: () => <VerlichtingFilter />
            }
        ]
    },
    {
        label: "Maten en gewichten",
        isOpen: true,
        fields: [
            {
                label: "Ledig gewicht (kilo)",
                isOpen: false,
                component: () => <LedigGewichtFilter />
            },
            {
                label: "Draaicirkel (meter)",
                isOpen: false,
                component: () => <DraaicirkelFilter />
            },
            {
                label: "Trekgewicht (kilo)",
                isOpen: false,
                showTooltip: true,
                filterTooltipName: "Trekgewicht",
                component: () => <TrekgewichtFilter />
            },
            {
                label: "Kofferbakinhoud (liter)",
                isOpen: false,
                component: () => <KofferbakinhoudFilter />
            },
            {
                label: "Aantal zitplaatsen",
                isOpen: false,
                component: () => <AantalZitplaatsenFilter />
            }
        ]
    },
    {
        label: "Milieu",
        isOpen: true,
        fields: [
            {
                label: "Energielabel",
                isOpen: false,
                component: () => <EnergieLabelFilter />
            },
            { label: "Emissieklasse", isOpen: false, component: () => <EmissieklasseFilter /> }
        ]
    },
    {
        label: "Aanbieder en garanties",
        isOpen: true,
        fields: [
            {
                label: "Garanties en zekerheden",
                isOpen: false,
                component: () => <GarantiesEnZekerhedenFilter />
            },
            {
                label: "Aanbieder",
                isOpen: false,
                component: () => <AanbiederFilter />
            }
        ]
    },
    {
        label: "Techniek",
        isOpen: true,
        fields: [
            {
                label: "Vermogen (PK)",
                isOpen: false,
                showTooltip: true,
                filterTooltipName: "Vermogen",
                component: () => <VermogenFilter />
            },
            {
                label: "Aantal cilinders",
                isOpen: false,
                component: () => <AantalCilindersFilter />
            },
            {
                label: "Verbruik (km per liter)",
                isOpen: false,
                component: () => <VerbruikFilter />
            },
            { label: "Actieradius (km)", isOpen: false, component: () => <ActieradiusFilter /> },
            { label: "Motorinhoud", isOpen: false, component: () => <MotorinhoudFilter /> }
        ]
    }
];

function mapToFilterComponent({
    label,
    isOpen,
    showTooltip,
    filterTooltipName,
    component: Component
}) {
    return (
        <FilterContainer
            key={label}
            label={label}
            showTooltip={showTooltip}
            filterTooltipName={filterTooltipName}
            isOpen={isOpen}
        >
            <Component />
        </FilterContainer>
    );
}

function mapToGroupComponent({ label, isOpen, fields, showTooltip, filterTooltipName }) {
    return (
        <FilterContainer
            key={label}
            label={label}
            isOpen={isOpen}
            showTooltip={showTooltip}
            filterTooltipName={filterTooltipName}
            isGroupContainer
        >
            {fields.map(mapToFilterComponent)}
        </FilterContainer>
    );
}

export const AdvancedSearchFields = () => {
    return (
        <>
            {basicFields.map(mapToFilterComponent)}
            {fieldGroups.map(mapToGroupComponent)}
        </>
    );
};
